(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    /* =========================================
   FC — PhotoSwipe Zoom Thumbnail Bar
   Adds a thumbnail strip + media counter
   at the bottom of the zoom lightbox.
   Includes ALL media types (images, videos,
   models) — not just images.
   Re-attaches after variant-triggered
   lightbox rebuilds via polling.
   ========================================= */
(function () {
  'use strict';

  function getThumbSrc(src) {
    if (!src) return '';
    return src.split('?')[0] + '?width=100&format=webp';
  }

  function attachToLightbox(gallery) {
    var lightbox = gallery.lightbox;
    if (!lightbox || lightbox.__fcThumbsAttached) return;
    lightbox.__fcThumbsAttached = true;

    lightbox.on('uiRegister', function () {
      var pswp = lightbox.pswp;
      var dataSource = pswp.options.dataSource;
      if (!dataSource || !dataSource.length || !pswp.element) return;

      /* Build thumb items from ALL data source items (images + videos + models) */
      var thumbItems = [];
      for (var idx = 0; idx < dataSource.length; idx++) {
        var item = dataSource[idx];
        var thumbSrc = '';
        var isNonImage = false;

        if (item.src) {
          thumbSrc = getThumbSrc(item.src);
        } else {
          isNonImage = true;
          /* Find preview thumbnail from gallery's nav slider strip */
          var itemId = item.id != null ? item.id : idx;
          var navThumb = gallery.querySelector(
            '.m-product-media--slider__thumbnails [data-index="' + itemId + '"] img'
          );
          if (navThumb) {
            thumbSrc = getThumbSrc(navThumb.src);
          }
        }

        thumbItems.push({ src: thumbSrc, pswpIndex: idx, isNonImage: isNonImage });
      }
      if (thumbItems.length === 0) return;

      /* Build DOM */
      var bar = document.createElement('div');
      bar.className = 'fc-pswp-thumbs';

      var counter = document.createElement('div');
      counter.className = 'fc-pswp-thumbs__counter';
      bar.appendChild(counter);

      var list = document.createElement('div');
      list.className = 'fc-pswp-thumbs__list';

      thumbItems.forEach(function (item, i) {
        var btn = document.createElement('button');
        btn.className = 'fc-pswp-thumbs__item';
        if (item.isNonImage) btn.classList.add('fc-pswp-thumbs__item--video');
        btn.setAttribute('type', 'button');
        btn.setAttribute('aria-label', 'Go to ' + (item.isNonImage ? 'video' : 'image') + ' ' + (i + 1));

        if (item.src) {
          var img = document.createElement('img');
          img.src = item.src;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 56;
          img.height = 56;
          btn.appendChild(img);
        }

        btn.addEventListener('click', function () {
          pswp.goTo(item.pswpIndex);
        });

        list.appendChild(btn);
      });

      bar.appendChild(list);
      pswp.element.appendChild(bar);

      /* Update counter + active thumb.
         Since all media are included, pswpIndex === thumb index. */
      function updateBar() {
        var currIndex = pswp.currIndex;
        counter.textContent = (currIndex + 1) + ' / ' + thumbItems.length;

        var thumbBtns = list.querySelectorAll('.fc-pswp-thumbs__item');
        for (var j = 0; j < thumbBtns.length; j++) {
          thumbBtns[j].classList.toggle('is-active', j === currIndex);
        }

        /* Scroll active thumb into view */
        if (thumbBtns[currIndex]) {
          thumbBtns[currIndex].scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest'
          });
        }
      }

      updateBar();

      pswp.on('change', function () {
        updateBar();
      });
    });
  }

  function init() {
    var galleries = document.querySelectorAll('media-gallery');
    galleries.forEach(function (gallery) {
      if (gallery.lightbox) {
        attachToLightbox(gallery);
      } else {
        var attempts = 0;
        var check = setInterval(function () {
          attempts++;
          if (gallery.lightbox) {
            clearInterval(check);
            attachToLightbox(gallery);
          }
          if (attempts > 50) clearInterval(check);
        }, 200);
      }

      /* Re-attach after variant-triggered lightbox rebuilds.
         variant-picker.js destroys and recreates the lightbox
         on every variant change — poll for new instances. */
      setInterval(function () {
        if (gallery.lightbox) attachToLightbox(gallery);
      }, 500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =========================================
   FC — Media Gallery Slide Counter
   Updates the "1 / 8" counter overlay on
   slide change. Only targets slider layouts.

   Key sync issues solved:
   1. product-media.js calls slideToLoop with
      runCallbacks:false — slideChange never
      fires during lightbox navigation.
   2. variant-picker.js destroys and recreates
      the lightbox on variant change — our
      event listeners die. We re-attach by
      watching for new lightbox instances.
   ========================================= */
(function () {
  'use strict';

  function syncCounters(gallery) {
    if (!gallery.slider) return;
    var index = gallery.slider.realIndex;

    var counterEl = gallery.querySelector('.fc-media-counter__current');
    if (counterEl) {
      counterEl.textContent = index + 1;
    }

    var paginationCurrent = gallery.querySelector('.swiper-pagination-current');
    if (paginationCurrent) {
      paginationCurrent.textContent = index + 1;
    }
  }

  function hookLightbox(gallery) {
    var lb = gallery.lightbox;
    if (!lb || lb.__fcSynced) return;
    lb.__fcSynced = true;

    lb.on('change', function () {
      syncCounters(gallery);
    });

    lb.on('destroy', function () {
      syncCounters(gallery);
    });
  }

  function attachCounter(gallery) {
    if (gallery.__fcCounterAttached) return;
    gallery.__fcCounterAttached = true;

    gallery.slider.on('slideChange', function () {
      syncCounters(gallery);
    });
    syncCounters(gallery);

    /* Continuously watch for lightbox instances.
       variant-picker.js destroys and rebuilds the
       lightbox on every variant change, so we must
       re-attach to each new instance. */
    setInterval(function () {
      if (gallery.lightbox) hookLightbox(gallery);
    }, 500);
  }

  function init() {
    var galleries = document.querySelectorAll(
      'media-gallery[data-layout="h-slider"], media-gallery[data-layout="v-slider"]'
    );

    galleries.forEach(function (gallery) {
      if (gallery.slider) {
        attachCounter(gallery);
      } else {
        var attempts = 0;
        var check = setInterval(function () {
          attempts++;
          if (gallery.slider) {
            clearInterval(check);
            attachCounter(gallery);
          }
          if (attempts > 50) clearInterval(check);
        }, 200);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
